import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "col-12 col-md-6" }

import { DateFilter, DateFiltersEnum, SelectOption } from "@/@types";
import { DateFilterOptions, dateRanges } from "@/utils";
import moment from "moment";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'DateFilters',
  props: {
    options: { default: () => (DateFilterOptions) },
    clearable: { type: Boolean, default: true }
  },
  emits: ["onChangeDate"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;



const range = ref();
const model = ref();
const dateOptions = ref<SelectOption[]>(__props.options);
const route = useRoute();

onMounted(() => {
  updateRange(route.query);
});

watch(route, (newRoute) => {
  updateRange(newRoute.query);
});

const updateRange = (query: any) => {
  if (query.date_start && query.date_end) {
    range.value = {
      date_start: moment(query.date_start),
      date_end: moment(query.date_end),
    };
  }
  updateOptions();
};

const updateOptions = () => {
  let value = "";

  const format = "YYYY-MM-DD";
  const startDate = range?.value?.date_start
    ? moment(range?.value?.date_start).format(format)
    : null;
  const endDate = range?.value?.date_end
    ? moment(range?.value?.date_end).format(format)
    : null;
  const todayDate = moment().format(format);
  const startOfMonth = moment().startOf("month").format(format);
  const endOfMonth = moment().endOf("month").format(format);

  const isToday = startDate === todayDate && endDate === todayDate;
  const isThisMonth = startDate === startOfMonth && endDate === endOfMonth;
  const isAll = !startDate && !endDate;

  if (isToday) value = DateFiltersEnum.today;
  if (isThisMonth) value = DateFiltersEnum.current_month;
  if (isAll) value = DateFiltersEnum.all;

  model.value = value;

  dateOptions.value = __props.options.map((elem) => ({
    ...elem,
    selected: elem?.value === value,
  }));
};

const handleDateChange = (event: any, type: string) => {
  const value = event.target?.value;
  const dateRange = dateRanges[value as DateFilter];
  if (dateRange.date_start && dateRange.date_end) {
    range.value = dateRange;
  }
  range.value = null;
  emits("onChangeDate", range?.value);
};

const handleDateRangeChange = (value: any) => {
  range.value = value;
  updateOptions();
  emits("onChangeDate", range?.value);
};

return (_ctx: any,_cache: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_DateRange = _resolveComponent("DateRange")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("label", {
          class: "input-group-text",
          for: "date_filter_select"
        }, "Período", -1)),
        _createVNode(_component_Select, {
          id: "date_filter_select",
          ref: "date-filter-select",
          onChange: handleDateChange,
          options: dateOptions.value,
          modelValue: model.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event))
        }, null, 8, ["options", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_DateRange, {
        onOnDateChange: handleDateRangeChange,
        range: range.value,
        clearable: _ctx.clearable,
        id: "date_filter_range_input"
      }, null, 8, ["range", "clearable"])
    ])
  ]))
}
}

})